var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBar',{attrs:{"transparentmenu":_vm.$route.path === '/' ? true : false}}),_c('v-main',{style:(_vm.$route.path === '/' ? 'margin-top: 0px' : 'margin-top: 70px')},[_c('router-view')],1),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }